import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DisconnectIntegrationMutation,
  DisconnectIntegrationMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const disconnectIntegrationQuery = graphql(`
  mutation disconnectIntegration($req: DisconnectIntegrationRequest!) {
    disconnectIntegration(DisconnectIntegrationRequest: $req)
  }
`);

export function useDisconnectIntegration(
  options?: UseMutationOptions<
    DisconnectIntegrationMutation,
    unknown,
    DisconnectIntegrationMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(disconnectIntegrationQuery, { ...options });
}
